<template>
  <div>
    <div
      v-if="!document || !document.path"
      class="">
      <button class="button is-white is-small">
        <input
          class="file-input has-cursor-pointer"
          type="file"
          accept="image/*, .pdf"
          name="resume"
          @change="uploadDocument($event.target.files)">
        <span class="">
          <span
            v-if="!loadingDoc"
            class="icon">
            <i class="fal fa-lg fa-paperclip"></i>
          </span>
          <span
            v-else
            class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </span>
          <span>
            Joindre un fichier
          </span>
        </span>
      </button>
    </div>
    <template v-else>
      <div class="column columns">
        <div class="column is-narrow">
          <span>{{ document.filename | truncate(40) }}</span>
        </div>
        <div
          class="column">
          <a
            class="icon has-text-grey is-self-centered tooltip is-tooltip-top"
            data-tooltip="Supprimer document lié"
            @click="unlink()"><i class="fal fa-unlink" /></a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { Upload } from '@/mixins'
export default {
  name: 'TicketFileUpload',
  mixins: [Upload],
  props: {
    document: {
      type: Object
    },
    source: {
      type: Object
    },
    multipleLoan: Boolean,
    index: Number
  },
  data () {
    return {
      validDocument: null,
      files: [],
      loadingDoc: false
    }
  },
  created () {

  },
  methods: {
    /**
      * unlink document
      */
    unlink () {
      this.$emit('delete', this.document)
    },
    /**
       * upload Document
       * @param {array} files
       */
    async uploadDocument (files) {
      this.files = new FormData()
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.validDocument = await this.checkAutorizedFile(file)
        this.files.append('file[]', file, file.name)
      }
      if (this.validDocument === false) {
        setTimeout(() => {
          this.validDocument = null
        }, 2000)
        return
      }
      let uploadFiles = this.files
      this.loadingDoc = true
      let config = {
        onUploadProgress: progressEvent => {
          this.progressData = Math.floor((progressEvent.loaded * 100) / progressEvent.total)
        }
      }
      try {
        await this.setFusToken()
        let res = await this.$fus.post({ data: uploadFiles, config })

        let hostedFile = res.data[0]
        hostedFile['display'] = true
        hostedFile['fus_id'] = hostedFile['id']
        delete hostedFile['size']
        delete hostedFile['uses']
        delete hostedFile['id']

        this.loadingDoc = false
        this.$emit('upload', hostedFile)
        this.$toasted.global.success('Le document à été téléchargé avec succès')
      } catch (e) {
        this.loadingDoc = false
        console.log(e)
      }
    }
  }
}
</script>

<style>

</style>
